// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css';
import 'iview/dist/styles/iview.css'
import api from './api'// 导入api接口
import {getCookie} from './utils/cookieUtil.js';//获取Cookie
import utils from './utils/utils.js'
import {setCookie} from "./utils/cookieUtil"; //引入全局变量
import './utils/global.js'//引入全局变量
import 'vue-easytable/libs/themes-base/index.css' //表格组件vue-easytable
import {VTable, VPagination} from 'vue-easytable'
import './permission'//这里进行路由后台获取的模拟
import JsEncrypt from 'jsencrypt'; //引入全局签名
import aes from './utils/aes.js'; //引入AES加密工具
import echarts from 'echarts' //引入echarts组件
import VueI18n from 'vue-i18n' //引入vue-i18n组件
import App from './App'
import '@/components/ef/index.css'
import Print from './utils/print.js'//引入全局变量
import {hasPermission} from './utils/permission.js'//按钮权限指令
import StringUtils from './utils/StringUtils.js'; //引入StringUtils工具
import router from './router'

Vue.use(Print); //打印
Vue.use(hasPermission) // 按钮权限指令
Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)

window.eventBus = new Vue();//通过eventBus传递数据
Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.prototype.$echarts=echarts //将echarts注册成Vue的全局属性

Vue.prototype.StringUtils = StringUtils; // 全局工具类

Vue.config.productionTip = false;
Vue.use(iView);

Vue.use(VueI18n);
const i18n=new VueI18n({
	locale:localStorage.getItem('locale') || 'zh',
	messages: {
      'zh': require('./i18n/lang/zh.js'),   // 中文语言包
      'en': require('./i18n/lang/en.js')    // 英文语言包
    }
})

new Vue({
  el: '#app',
  router,
  i18n,
  components: {App},
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js